import React, { ReactNode } from "react";
import { ErrorBoundary } from "@rollbar/react";
import { useTranslation } from "components/translations/useTranslation";
import { Button, ButtonType } from "components/common/Button.component";

// a full load of the app root, since whatever state broke this panel is likely still in the store
const goHome = () => window.location.assign("/");

export const PanelErrorFallback = (): React.ReactElement => {
    const { translate } = useTranslation();

    return (
        <div className="aw:flex aw:h-full aw:flex-col aw:items-center aw:justify-center aw:gap-12 aw:p-24 aw:text-center">
            <div className="aw:text-[14px] aw:font-semibold">{translate("errorPage.panel.title")}</div>
            <div className="aw:text-[13px]">{translate("errorPage.panel.msg")}</div>
            <Button type={ButtonType.SECONDARY} onClick={goHome} text={translate("errorPage.goToHomepage")} />
        </div>
    );
};

/**
 * Contains a crash to the panel that caused it, so one broken section no longer takes the whole
 * details screen down with it. `panel` names the section in Rollbar.
 */
export const PanelErrorBoundary = ({ panel, children }: { panel: string; children: ReactNode }): React.ReactElement => (
    <ErrorBoundary fallbackUI={PanelErrorFallback} errorMessage={`panel crashed: ${panel}`} extra={{ panel }}>
        {children}
    </ErrorBoundary>
);
